import { useState } from "react";

export function useToast() {
  const [toast, setToast] = useState("");

  function showToast(message: string) {
    setToast(message);
    window.setTimeout(() => setToast(""), 2400);
  }

  return { toast, showToast };
}
